import { JsonObject, JsonProperty } from 'typescript-json-serializer';

export enum MarketAppVisibility {
    DASHBOARD_ZONE = 'DASHBOARD_ZONE',
    DASHBOARD_LOCATION = 'DASHBOARD_LOCATION',
}

@JsonObject()
export class MarketAppView {
    constructor(
        @JsonProperty({ required: true }) readonly id: number,
        @JsonProperty({ required: true }) readonly key: string,
        @JsonProperty({ required: true }) readonly title: string
    ) {}
}
